
















































import { Vue, Component, Prop } from "vue-property-decorator"; // eslint-disable-line no-unused-vars
import CdkFilterPassBadges from "../../CdkFilterPassBadge/CdkFilterPassBadges.vue"; // eslint-disable-line no-unused-vars
import CdkImage from "./CdkImage.vue";
import { FilterPassBadge } from "@/utils/filterPassBadges";

@Component({
  components: {
    CdkFilterPassBadges,
    CdkImage
  }
})
export default class ImageContent extends Vue {
  @Prop({
    type: String,
    required: true
  })
  guid?: string;

  @Prop({
    type: String,
    required: false,
    default: ""
  })
  genre?: string;

  @Prop({
    type: String,
    required: true
  })
  title!: string;

  @Prop({
    type: String,
    required: false
  })
  description?: string;

  @Prop({
    type: Boolean,
    required: false,
    default: false
  })
  isEmbargoed?: boolean;

  @Prop({
    type: Boolean,
    default: false,
    required: false
  })
  isCompact?: boolean;

  @Prop({
    type: String,
    required: false,
    default: ""
  })
  embargoed?: string;

  @Prop({
    type: Array,
    required: false,
    default: () => []
  })
  filterPassBadges?: FilterPassBadge[];

  @Prop({
    type: String,
    required: true
  })
  residref?: string;

  @Prop({
    type: String
  })
  layoutOrientation?: string;

  visibilityChanged(isVisible) {
    if (isVisible) {
      this.$store.dispatch("newsItems/fetchImage", {
        isThumbnail: false,
        residref: this.residref,
        guid: this.guid
      });
    }
  }
}
